import React, { useState, useEffect } from "react";
import "../styles/Reportes.css";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import { useApiFetch } from "../utils/apiFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

function Reportes() {
    const { identidad, logout } = useGlobal();
    const apiFetch = useApiFetch();

    const [solicitudes, setSolicitudes] = useState([]);
    const [hardware, setHardware] = useState([]);
    const [red, setRed] = useState([]);
    const [software, setSoftware] = useState([]);

    const [mensaje, setMensaje] = useState("");

    const exportarPDF = (solicitudes, hardware, red, software) => {
        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado general
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Reporte Consolidado de Indicadores", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla 1 Solicitudes
        doc.setFontSize(11);
        doc.text("Indicadores de Solicitudes", 14, 48);
        autoTable(doc, {
            startY: 52,
            head: [["Indicador", "Cantidad", "%"]],
            body: solicitudes.map(i => [i.indicador, i.valor, i.porcentaje + "%"]),
            theme: "grid"
        });

        // Tabla 2 Hardware 
        doc.setFontSize(11);
        doc.text("Indicadores de Equipo de Cómputo", 14, doc.lastAutoTable.finalY + 10);
        autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 14,
            head: [["Indicador", "Cantidad", "%"]],
            body: hardware.map(i => [i.indicador, i.valor, i.porcentaje + "%"]),
            theme: "grid"
        });


        // Tabla 3 Red
        doc.setFontSize(11);
        doc.text("Indicadores de Recursos de Red", 14, doc.lastAutoTable.finalY + 10);
        autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 14,
            head: [["Indicador", "Valor", "%"]],
            body: red.map(i => [i.indicador, i.valor, i.porcentaje + "%"]),
            theme: "grid"
        });

        // Tabla 4 Software
        doc.setFontSize(11);
        doc.text("Indicadores de IPs", 14, doc.lastAutoTable.finalY + 10);
        autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 14,
            head: [["Indicador", "Cantidad", "%"]],
            body: software.map(i => [i.indicador, i.valor, i.porcentaje + "%"]),
            theme: "grid"
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("reporte_consolidado.pdf");
    };

    // Lista 1 Solicitudes
    useEffect(() => {
        if (!identidad) return;
        apiFetch("solicitudes.php", { method: "GET" }, logout)
            .then(data => {
                if (data.status === "success") setSolicitudes(data.data || []);
            })
            .catch(() => setMensaje("Error al cargar solicitudes"));
    }, [identidad]);

    // Lista 2 Hardware
    useEffect(() => {
        if (!identidad) return;
        apiFetch("hardware.php", { method: "GET" }, logout)
            .then(data => {
                if (data.status === "success") setHardware(data.data || []);
            })
            .catch(() => setMensaje("Error al cargar hardware"));
    }, [identidad]);

    // Lista 3 Red
    useEffect(() => {
        if (!identidad) return;
        apiFetch("red.php", { method: "GET" }, logout)
            .then(data => {
                if (data.status === "success") setRed(data.data || []);
            })
            .catch(() => setMensaje("Error al cargar red"));
    }, [identidad]);

    // Lista 4 Software
    useEffect(() => {
        if (!identidad) return;
        apiFetch("software.php", { method: "GET" }, logout)
            .then(data => {
                if (data.status === "success") setSoftware(data.data || []);
            })
            .catch(() => setMensaje("Error al cargar software"));
    }, [identidad]);

    if (mensaje) return <p className="error">{mensaje}</p>;

    return (
        <>
            <div className="form-buttons">
                <button onClick={() => exportarPDF(solicitudes, hardware, red, software)}>
                    Exportar PDF
                </button>
            </div>

            <div className="reportes-grid">
                {/* Solicitudes */}
                <div className="control-tabla">
                    <h2>Indicadores de Solicitudes</h2>
                    <table className="tabla-estandar">
                        <thead>
                            <tr><th>Indicador</th><th>Cantidad</th><th>%</th></tr>
                        </thead>
                        <tbody>
                            {solicitudes.map((item, i) => (
                                <tr key={i}>
                                    <td data-label="Indicador">{item.indicador}</td>
                                    <td data-label="Valor">{item.valor}</td>
                                    <td data-label="Porcentaje">{item.porcentaje}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Hardware */}
                <div className="control-tabla">
                    <h2>Indicadores de Equipo de Cómputo</h2>
                    <table className="tabla-estandar">
                        <thead>
                            <tr>
                                <th>Indicador</th>
                                <th>Cantidad</th>
                                <th>%</th>
                            </tr>
                        </thead>
                        <tbody>
                            {hardware.map((item, index) => (
                                <tr key={index}>
                                    <td data-label="Indicador">{item.indicador}</td>
                                    <td data-label="Valor">{item.valor}</td>
                                    <td data-label="Porcentaje">{item.porcentaje}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Red */}
                <div className="control-tabla">
                    <h2>Indicadores de Recursos de Red</h2>
                    <table className="tabla-estandar">
                        <thead>
                            <tr><th>Indicador</th><th>Valor</th><th>%</th></tr>
                        </thead>
                        <tbody>
                            {red.map((item, i) => (
                                <tr key={i}>
                                    <td data-label="Indicador">{item.indicador}</td>
                                    <td data-label="Valor">{item.valor}</td>
                                    <td data-label="Porcentaje">{item.porcentaje}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Software */}
                <div className="control-tabla">
                    <h2>Indicadores de IPs</h2>
                    <table className="tabla-estandar">
                        <thead>
                            <tr><th>Indicador</th><th>Cantidad</th><th>%</th></tr>
                        </thead>
                        <tbody>
                            {software.map((item, i) => (
                                <tr key={i}>
                                    <td data-label="Indicador">{item.indicador}</td>
                                    <td data-label="Valor">{item.valor}</td>
                                    <td data-label="Porcentaje">{item.porcentaje}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default Reportes;
